const _c0 = ["pPanelMenuSub", ""];
const _c1 = a0 => ({
  processedItem: a0
});
const _c2 = () => ({
  exact: false
});
const _c3 = a0 => ({
  $implicit: a0
});
function PanelMenuSub_ng_template_0_li_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "li", 4);
  }
  if (rf & 2) {
    const processedItem_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.cn(ctx_r1.cx("separator"), ctx_r1.getItemProp(processedItem_r1, "styleClass")));
    i0.ɵɵproperty("pBind", ctx_r1.ptm("separator"));
  }
}
function PanelMenuSub_ng_template_0_li_1_ng_container_2_a_1_ng_container_1_ng_container_1__svg_svg_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 19);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(6);
    const processedItem_r1 = ctx_r3.$implicit;
    const index_r5 = ctx_r3.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.cn(ctx_r1.cx("submenuIcon"), ctx_r1.getItemProp(processedItem_r1, "icon")));
    i0.ɵɵproperty("ngStyle", ctx_r1.getItemProp(processedItem_r1, "iconStyle"))("pBind", ctx_r1.getPTOptions(processedItem_r1, index_r5, "submenuIcon"));
  }
}
function PanelMenuSub_ng_template_0_li_1_ng_container_2_a_1_ng_container_1_ng_container_1__svg_svg_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 20);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(6);
    const processedItem_r1 = ctx_r3.$implicit;
    const index_r5 = ctx_r3.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.cn(ctx_r1.cx("submenuIcon"), ctx_r1.getItemProp(processedItem_r1, "icon")));
    i0.ɵɵproperty("ngStyle", ctx_r1.getItemProp(processedItem_r1, "iconStyle"))("pBind", ctx_r1.getPTOptions(processedItem_r1, index_r5, "submenuIcon"));
  }
}
function PanelMenuSub_ng_template_0_li_1_ng_container_2_a_1_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PanelMenuSub_ng_template_0_li_1_ng_container_2_a_1_ng_container_1_ng_container_1__svg_svg_1_Template, 1, 4, "svg", 17)(2, PanelMenuSub_ng_template_0_li_1_ng_container_2_a_1_ng_container_1_ng_container_1__svg_svg_2_Template, 1, 4, "svg", 18);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const processedItem_r1 = i0.ɵɵnextContext(5).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isItemActive(processedItem_r1));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isItemActive(processedItem_r1));
  }
}
function PanelMenuSub_ng_template_0_li_1_ng_container_2_a_1_ng_container_1_2_ng_template_0_Template(rf, ctx) {}
function PanelMenuSub_ng_template_0_li_1_ng_container_2_a_1_ng_container_1_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, PanelMenuSub_ng_template_0_li_1_ng_container_2_a_1_ng_container_1_2_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function PanelMenuSub_ng_template_0_li_1_ng_container_2_a_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PanelMenuSub_ng_template_0_li_1_ng_container_2_a_1_ng_container_1_ng_container_1_Template, 3, 2, "ng-container", 7)(2, PanelMenuSub_ng_template_0_li_1_ng_container_2_a_1_ng_container_1_2_Template, 1, 0, null, 16);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.panelMenu.submenuIconTemplate && !ctx_r1.panelMenu._submenuIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.panelMenu.submenuIconTemplate || ctx_r1.panelMenu._submenuIconTemplate);
  }
}
function PanelMenuSub_ng_template_0_li_1_ng_container_2_a_1_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 21);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(4);
    const processedItem_r1 = ctx_r3.$implicit;
    const index_r5 = ctx_r3.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.cn(ctx_r1.cx("itemIcon"), ctx_r1.getItemProp(processedItem_r1, "icon"), ctx_r1.getItemProp(processedItem_r1, "iconClass")));
    i0.ɵɵproperty("ngStyle", ctx_r1.getItemProp(processedItem_r1, "iconStyle"))("pBind", ctx_r1.getPTOptions(processedItem_r1, index_r5, "itemIcon"));
  }
}
function PanelMenuSub_ng_template_0_li_1_ng_container_2_a_1_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(4);
    const processedItem_r1 = ctx_r3.$implicit;
    const index_r5 = ctx_r3.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.cn(ctx_r1.cx("itemLabel"), ctx_r1.getItemProp(processedItem_r1, "labelClass")));
    i0.ɵɵproperty("ngStyle", ctx_r1.getItemProp(processedItem_r1, "labelStyle"))("pBind", ctx_r1.getPTOptions(processedItem_r1, index_r5, "itemLabel"));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.getItemProp(processedItem_r1, "label"));
  }
}
function PanelMenuSub_ng_template_0_li_1_ng_container_2_a_1_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 22);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(4);
    const processedItem_r1 = ctx_r3.$implicit;
    const index_r5 = ctx_r3.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.cn(ctx_r1.cx("itemLabel"), ctx_r1.getItemProp(processedItem_r1, "labelClass")));
    i0.ɵɵproperty("ngStyle", ctx_r1.getItemProp(processedItem_r1, "labelStyle"))("innerHTML", ctx_r1.getItemProp(processedItem_r1, "label"), i0.ɵɵsanitizeHtml)("pBind", ctx_r1.getPTOptions(processedItem_r1, index_r5, "itemLabel"));
  }
}
function PanelMenuSub_ng_template_0_li_1_ng_container_2_a_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 13);
    i0.ɵɵtemplate(1, PanelMenuSub_ng_template_0_li_1_ng_container_2_a_1_ng_container_1_Template, 3, 2, "ng-container", 7)(2, PanelMenuSub_ng_template_0_li_1_ng_container_2_a_1_span_2_Template, 1, 4, "span", 14)(3, PanelMenuSub_ng_template_0_li_1_ng_container_2_a_1_span_3_Template, 2, 5, "span", 15)(4, PanelMenuSub_ng_template_0_li_1_ng_container_2_a_1_ng_template_4_Template, 1, 5, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const htmlLabel_r6 = i0.ɵɵreference(5);
    const ctx_r3 = i0.ɵɵnextContext(3);
    const processedItem_r1 = ctx_r3.$implicit;
    const index_r5 = ctx_r3.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.cn(ctx_r1.cx("itemLink"), ctx_r1.getItemProp(processedItem_r1, "linkClass")));
    i0.ɵɵproperty("ngStyle", ctx_r1.getItemProp(processedItem_r1, "linkStyle"))("target", ctx_r1.getItemProp(processedItem_r1, "target"))("pBind", ctx_r1.getPTOptions(processedItem_r1, index_r5, "itemLink"));
    i0.ɵɵattribute("href", ctx_r1.getItemProp(processedItem_r1, "url"), i0.ɵɵsanitizeUrl)("title", ctx_r1.getItemProp(processedItem_r1, "title"))("data-automationid", ctx_r1.getItemProp(processedItem_r1, "automationId"))("tabindex", !!ctx_r1.parentExpanded ? "0" : "-1");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isItemGroup(processedItem_r1));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", processedItem_r1.icon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (processedItem_r1.item == null ? null : processedItem_r1.item.escape) !== false)("ngIfElse", htmlLabel_r6);
  }
}
function PanelMenuSub_ng_template_0_li_1_ng_container_2_a_2_ng_container_1_ng_container_1__svg_svg_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 19);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(6);
    const processedItem_r1 = ctx_r3.$implicit;
    const index_r5 = ctx_r3.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.cn(ctx_r1.cx("submenuIcon"), ctx_r1.getItemProp(processedItem_r1, "icon")));
    i0.ɵɵproperty("ngStyle", ctx_r1.getItemProp(processedItem_r1, "iconStyle"))("pBind", ctx_r1.getPTOptions(processedItem_r1, index_r5, "submenuIcon"));
  }
}
function PanelMenuSub_ng_template_0_li_1_ng_container_2_a_2_ng_container_1_ng_container_1__svg_svg_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 20);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(6);
    const processedItem_r1 = ctx_r3.$implicit;
    const index_r5 = ctx_r3.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.cn(ctx_r1.cx("submenuIcon"), ctx_r1.getItemProp(processedItem_r1, "icon")));
    i0.ɵɵproperty("ngStyle", ctx_r1.getItemProp(processedItem_r1, "iconStyle"))("pBind", ctx_r1.getPTOptions(processedItem_r1, index_r5, "submenuIcon"));
  }
}
function PanelMenuSub_ng_template_0_li_1_ng_container_2_a_2_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PanelMenuSub_ng_template_0_li_1_ng_container_2_a_2_ng_container_1_ng_container_1__svg_svg_1_Template, 1, 4, "svg", 17)(2, PanelMenuSub_ng_template_0_li_1_ng_container_2_a_2_ng_container_1_ng_container_1__svg_svg_2_Template, 1, 4, "svg", 18);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const processedItem_r1 = i0.ɵɵnextContext(5).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isItemActive(processedItem_r1));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isItemActive(processedItem_r1));
  }
}
function PanelMenuSub_ng_template_0_li_1_ng_container_2_a_2_ng_container_1_2_ng_template_0_Template(rf, ctx) {}
function PanelMenuSub_ng_template_0_li_1_ng_container_2_a_2_ng_container_1_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, PanelMenuSub_ng_template_0_li_1_ng_container_2_a_2_ng_container_1_2_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function PanelMenuSub_ng_template_0_li_1_ng_container_2_a_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PanelMenuSub_ng_template_0_li_1_ng_container_2_a_2_ng_container_1_ng_container_1_Template, 3, 2, "ng-container", 7)(2, PanelMenuSub_ng_template_0_li_1_ng_container_2_a_2_ng_container_1_2_Template, 1, 0, null, 16);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.panelMenu.submenuIconTemplate && !ctx_r1.panelMenu._submenuIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.panelMenu.submenuIconTemplate && ctx_r1.panelMenu._submenuIconTemplate);
  }
}
function PanelMenuSub_ng_template_0_li_1_ng_container_2_a_2_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 21);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(4);
    const processedItem_r1 = ctx_r3.$implicit;
    const index_r5 = ctx_r3.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.cn(ctx_r1.cx("itemIcon"), ctx_r1.getItemProp(processedItem_r1, "icon"), ctx_r1.getItemProp(processedItem_r1, "iconClass")));
    i0.ɵɵproperty("ngStyle", ctx_r1.getItemProp(processedItem_r1, "iconStyle"))("pBind", ctx_r1.getPTOptions(processedItem_r1, index_r5, "itemIcon"));
  }
}
function PanelMenuSub_ng_template_0_li_1_ng_container_2_a_2_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 22);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(4);
    const processedItem_r1 = ctx_r3.$implicit;
    const index_r5 = ctx_r3.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.cn(ctx_r1.cx("itemLabel"), ctx_r1.getItemProp(processedItem_r1, "labelClass")));
    i0.ɵɵproperty("ngStyle", ctx_r1.getItemProp(processedItem_r1, "labelStyle"))("innerHTML", ctx_r1.getItemProp(processedItem_r1, "label"), i0.ɵɵsanitizeHtml)("pBind", ctx_r1.getPTOptions(processedItem_r1, index_r5, "itemLabel"));
  }
}
function PanelMenuSub_ng_template_0_li_1_ng_container_2_a_2_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const processedItem_r1 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.cn(ctx_r1.cx("badge"), ctx_r1.getItemProp(processedItem_r1, "badgeStyleClass")));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(processedItem_r1.badge);
  }
}
function PanelMenuSub_ng_template_0_li_1_ng_container_2_a_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 23);
    i0.ɵɵtemplate(1, PanelMenuSub_ng_template_0_li_1_ng_container_2_a_2_ng_container_1_Template, 3, 2, "ng-container", 7)(2, PanelMenuSub_ng_template_0_li_1_ng_container_2_a_2_span_2_Template, 1, 4, "span", 14)(3, PanelMenuSub_ng_template_0_li_1_ng_container_2_a_2_span_3_Template, 1, 5, "span", 24)(4, PanelMenuSub_ng_template_0_li_1_ng_container_2_a_2_span_4_Template, 2, 3, "span", 25);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(3);
    const processedItem_r1 = ctx_r3.$implicit;
    const index_r5 = ctx_r3.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.cn(ctx_r1.cx("itemLink"), ctx_r1.getItemProp(processedItem_r1, "linkClass")));
    i0.ɵɵproperty("routerLink", ctx_r1.getItemProp(processedItem_r1, "routerLink"))("queryParams", ctx_r1.getItemProp(processedItem_r1, "queryParams"))("routerLinkActive", "p-panelmenu-item-link-active")("routerLinkActiveOptions", ctx_r1.getItemProp(processedItem_r1, "routerLinkActiveOptions") || i0.ɵɵpureFunction0(22, _c2))("ngStyle", ctx_r1.getItemProp(processedItem_r1, "linkStyle"))("target", ctx_r1.getItemProp(processedItem_r1, "target"))("fragment", ctx_r1.getItemProp(processedItem_r1, "fragment"))("queryParamsHandling", ctx_r1.getItemProp(processedItem_r1, "queryParamsHandling"))("preserveFragment", ctx_r1.getItemProp(processedItem_r1, "preserveFragment"))("skipLocationChange", ctx_r1.getItemProp(processedItem_r1, "skipLocationChange"))("replaceUrl", ctx_r1.getItemProp(processedItem_r1, "replaceUrl"))("state", ctx_r1.getItemProp(processedItem_r1, "state"))("pBind", ctx_r1.getPTOptions(processedItem_r1, index_r5, "itemLink"));
    i0.ɵɵattribute("title", ctx_r1.getItemProp(processedItem_r1, "title"))("data-automationid", ctx_r1.getItemProp(processedItem_r1, "automationId"))("tabindex", !!ctx_r1.parentExpanded ? "0" : "-1");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isItemGroup(processedItem_r1));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", processedItem_r1.icon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.getItemProp(processedItem_r1, "label"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", processedItem_r1.badge);
  }
}
function PanelMenuSub_ng_template_0_li_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PanelMenuSub_ng_template_0_li_1_ng_container_2_a_1_Template, 6, 13, "a", 11)(2, PanelMenuSub_ng_template_0_li_1_ng_container_2_a_2_Template, 5, 23, "a", 12);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const processedItem_r1 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.getItemProp(processedItem_r1, "routerLink"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.getItemProp(processedItem_r1, "routerLink"));
  }
}
function PanelMenuSub_ng_template_0_li_1_ng_container_3_1_ng_template_0_Template(rf, ctx) {}
function PanelMenuSub_ng_template_0_li_1_ng_container_3_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, PanelMenuSub_ng_template_0_li_1_ng_container_3_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function PanelMenuSub_ng_template_0_li_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PanelMenuSub_ng_template_0_li_1_ng_container_3_1_Template, 1, 0, null, 26);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const processedItem_r1 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.itemTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c3, processedItem_r1.item));
  }
}
function PanelMenuSub_ng_template_0_li_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 5)(1, "div", 6);
    i0.ɵɵlistener("click", function PanelMenuSub_ng_template_0_li_1_Template_div_click_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const processedItem_r1 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onItemClick($event, processedItem_r1));
    });
    i0.ɵɵtemplate(2, PanelMenuSub_ng_template_0_li_1_ng_container_2_Template, 3, 2, "ng-container", 7)(3, PanelMenuSub_ng_template_0_li_1_ng_container_3_Template, 2, 4, "ng-container", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 8)(5, "div", 9)(6, "ul", 10);
    i0.ɵɵlistener("itemToggle", function PanelMenuSub_ng_template_0_li_1_Template_ul_itemToggle_6_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onItemToggle($event));
    });
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    const processedItem_r1 = ctx_r3.$implicit;
    const index_r5 = ctx_r3.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.cn(ctx_r1.cx("item", i0.ɵɵpureFunction1(39, _c1, processedItem_r1)), ctx_r1.getItemProp(processedItem_r1, "styleClass")));
    i0.ɵɵproperty("ngStyle", ctx_r1.getItemProp(processedItem_r1, "style"))("pTooltip", ctx_r1.getItemProp(processedItem_r1, "tooltip"))("pTooltipUnstyled", ctx_r1.unstyled())("pBind", ctx_r1.getPTOptions(processedItem_r1, index_r5, "item"))("tooltipOptions", ctx_r1.getItemProp(processedItem_r1, "tooltipOptions"));
    i0.ɵɵattribute("id", ctx_r1.getItemId(processedItem_r1))("aria-label", ctx_r1.getItemProp(processedItem_r1, "label"))("aria-expanded", ctx_r1.isItemGroup(processedItem_r1) ? ctx_r1.isItemActive(processedItem_r1) : undefined)("aria-level", ctx_r1.level + 1)("aria-setsize", ctx_r1.getAriaSetSize())("aria-posinset", ctx_r1.getAriaPosInset(index_r5))("data-p-disabled", ctx_r1.isItemDisabled(processedItem_r1))("data-p-focused", ctx_r1.isItemFocused(processedItem_r1));
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r1.cx("itemContent"));
    i0.ɵɵproperty("pBind", ctx_r1.getPTOptions(processedItem_r1, index_r5, "itemContent"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.itemTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.itemTemplate);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r1.cx("contentContainer", i0.ɵɵpureFunction1(41, _c1, processedItem_r1)));
    i0.ɵɵproperty("pMotion", ctx_r1.isItemVisible(processedItem_r1) && ctx_r1.isItemGroup(processedItem_r1) && ctx_r1.isItemExpanded(processedItem_r1))("pMotionOptions", ctx_r1.motionOptions());
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r1.cx("contentWrapper"));
    i0.ɵɵproperty("pBind", ctx_r1.ptm("contentWrapper"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r1.getItemId(processedItem_r1) + "_list")("panelId", ctx_r1.panelId)("items", processedItem_r1 == null ? null : processedItem_r1.items)("itemTemplate", ctx_r1.itemTemplate)("transitionOptions", ctx_r1.transitionOptions)("focusedItemId", ctx_r1.focusedItemId)("activeItemPath", ctx_r1.activeItemPath)("level", ctx_r1.level + 1)("pt", ctx_r1.pt())("unstyled", ctx_r1.unstyled())("parentExpanded", !!ctx_r1.parentExpanded && ctx_r1.isItemExpanded(processedItem_r1))("motionOptions", ctx_r1.motionOptions());
  }
}
function PanelMenuSub_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, PanelMenuSub_ng_template_0_li_0_Template, 1, 3, "li", 2)(1, PanelMenuSub_ng_template_0_li_1_Template, 7, 43, "li", 3);
  }
  if (rf & 2) {
    const processedItem_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", processedItem_r1.separator);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !processedItem_r1.separator && ctx_r1.isItemVisible(processedItem_r1));
  }
}
const _c4 = ["submenu"];
const _c5 = ["pPanelMenuList", ""];
const _c6 = ["submenuicon"];
const _c7 = ["headericon"];
const _c8 = ["item"];
const _c9 = ["container"];
const _c10 = a0 => ({
  item: a0
});
function PanelMenu_ng_container_0_div_1_ng_container_3_a_1_ng_container_1_ng_container_1__svg_svg_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 19);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(6);
    const item_r3 = ctx_r1.$implicit;
    const i_r4 = ctx_r1.index;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r4.cx("submenuIcon"));
    i0.ɵɵproperty("pBind", ctx_r4.getPTOptions("submenuIcon", item_r3, i_r4));
  }
}
function PanelMenu_ng_container_0_div_1_ng_container_3_a_1_ng_container_1_ng_container_1__svg_svg_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 20);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(6);
    const item_r3 = ctx_r1.$implicit;
    const i_r4 = ctx_r1.index;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r4.cx("submenuIcon"));
    i0.ɵɵproperty("pBind", ctx_r4.getPTOptions("submenuIcon", item_r3, i_r4));
  }
}
function PanelMenu_ng_container_0_div_1_ng_container_3_a_1_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PanelMenu_ng_container_0_div_1_ng_container_3_a_1_ng_container_1_ng_container_1__svg_svg_1_Template, 1, 3, "svg", 17)(2, PanelMenu_ng_container_0_div_1_ng_container_3_a_1_ng_container_1_ng_container_1__svg_svg_2_Template, 1, 3, "svg", 18);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext(5).$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.isItemActive(item_r3));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r4.isItemActive(item_r3));
  }
}
function PanelMenu_ng_container_0_div_1_ng_container_3_a_1_ng_container_1_2_ng_template_0_Template(rf, ctx) {}
function PanelMenu_ng_container_0_div_1_ng_container_3_a_1_ng_container_1_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, PanelMenu_ng_container_0_div_1_ng_container_3_a_1_ng_container_1_2_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function PanelMenu_ng_container_0_div_1_ng_container_3_a_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PanelMenu_ng_container_0_div_1_ng_container_3_a_1_ng_container_1_ng_container_1_Template, 3, 2, "ng-container", 7)(2, PanelMenu_ng_container_0_div_1_ng_container_3_a_1_ng_container_1_2_Template, 1, 0, null, 16);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r4.headerIconTemplate && !ctx_r4._headerIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r4.headerIconTemplate || ctx_r4._headerIconTemplate);
  }
}
function PanelMenu_ng_container_0_div_1_ng_container_3_a_1_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 4);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    const item_r3 = ctx_r1.$implicit;
    const i_r4 = ctx_r1.index;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r4.cn(ctx_r4.cx("headerIcon"), item_r3.icon, ctx_r4.getItemProp(item_r3, "iconClass")));
    i0.ɵɵproperty("ngStyle", ctx_r4.getItemProp(item_r3, "iconStyle"))("pBind", ctx_r4.getPTOptions("headerIcon", item_r3, i_r4));
  }
}
function PanelMenu_ng_container_0_div_1_ng_container_3_a_1_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    const item_r3 = ctx_r1.$implicit;
    const i_r4 = ctx_r1.index;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r4.cn(ctx_r4.cx("headerLabel"), ctx_r4.getItemProp(item_r3, "labelClass")));
    i0.ɵɵproperty("ngStyle", ctx_r4.getItemProp(item_r3, "labelStyle"))("pBind", ctx_r4.getPTOptions("headerLabel", item_r3, i_r4));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r4.getItemProp(item_r3, "label"));
  }
}
function PanelMenu_ng_container_0_div_1_ng_container_3_a_1_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 21);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    const item_r3 = ctx_r1.$implicit;
    const i_r4 = ctx_r1.index;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r4.cn(ctx_r4.cx("headerLabel"), ctx_r4.getItemProp(item_r3, "labelClass")));
    i0.ɵɵproperty("ngStyle", ctx_r4.getItemProp(item_r3, "labelStyle"))("innerHTML", ctx_r4.getItemProp(item_r3, "label"), i0.ɵɵsanitizeHtml)("pBind", ctx_r4.getPTOptions("headerLabel", item_r3, i_r4));
  }
}
function PanelMenu_ng_container_0_div_1_ng_container_3_a_1_span_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r4.cn(ctx_r4.cx("badge"), ctx_r4.getItemProp(item_r3, "badgeStyleClass")));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r4.getItemProp(item_r3, "badge"));
  }
}
function PanelMenu_ng_container_0_div_1_ng_container_3_a_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 13);
    i0.ɵɵtemplate(1, PanelMenu_ng_container_0_div_1_ng_container_3_a_1_ng_container_1_Template, 3, 2, "ng-container", 7)(2, PanelMenu_ng_container_0_div_1_ng_container_3_a_1_span_2_Template, 1, 4, "span", 3)(3, PanelMenu_ng_container_0_div_1_ng_container_3_a_1_span_3_Template, 2, 5, "span", 14)(4, PanelMenu_ng_container_0_div_1_ng_container_3_a_1_ng_template_4_Template, 1, 5, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(6, PanelMenu_ng_container_0_div_1_ng_container_3_a_1_span_6_Template, 2, 3, "span", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const htmlLabel_r6 = i0.ɵɵreference(5);
    const ctx_r1 = i0.ɵɵnextContext(3);
    const item_r3 = ctx_r1.$implicit;
    const i_r4 = ctx_r1.index;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r4.cn(ctx_r4.cx("headerLink"), ctx_r4.getItemProp(item_r3, "linkClass")));
    i0.ɵɵproperty("target", ctx_r4.getItemProp(item_r3, "target"))("ngStyle", ctx_r4.getItemProp(item_r3, "linkStyle"))("pBind", ctx_r4.getPTOptions("headerLink", item_r3, i_r4));
    i0.ɵɵattribute("href", ctx_r4.getItemProp(item_r3, "url"), i0.ɵɵsanitizeUrl)("tabindex", -1)("title", ctx_r4.getItemProp(item_r3, "title"))("data-automationid", ctx_r4.getItemProp(item_r3, "automationId"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.isItemGroup(item_r3));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r3.icon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.getItemProp(item_r3, "escape") !== false)("ngIfElse", htmlLabel_r6);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r4.getItemProp(item_r3, "badge"));
  }
}
function PanelMenu_ng_container_0_div_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PanelMenu_ng_container_0_div_1_ng_container_3_a_1_Template, 7, 14, "a", 12);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r4.getItemProp(item_r3, "routerLink"));
  }
}
function PanelMenu_ng_container_0_div_1_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function PanelMenu_ng_container_0_div_1_a_5_ng_container_1_ng_container_1__svg_svg_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 19);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    const item_r3 = ctx_r1.$implicit;
    const i_r4 = ctx_r1.index;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r4.cx("submenuIcon"));
    i0.ɵɵproperty("pBind", ctx_r4.getPTOptions("submenuIcon", item_r3, i_r4));
  }
}
function PanelMenu_ng_container_0_div_1_a_5_ng_container_1_ng_container_1__svg_svg_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 20);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    const item_r3 = ctx_r1.$implicit;
    const i_r4 = ctx_r1.index;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r4.cx("submenuIcon"));
    i0.ɵɵproperty("pBind", ctx_r4.getPTOptions("submenuIcon", item_r3, i_r4));
  }
}
function PanelMenu_ng_container_0_div_1_a_5_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PanelMenu_ng_container_0_div_1_a_5_ng_container_1_ng_container_1__svg_svg_1_Template, 1, 3, "svg", 17)(2, PanelMenu_ng_container_0_div_1_a_5_ng_container_1_ng_container_1__svg_svg_2_Template, 1, 3, "svg", 18);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.isItemActive(item_r3));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r4.isItemActive(item_r3));
  }
}
function PanelMenu_ng_container_0_div_1_a_5_ng_container_1_2_ng_template_0_Template(rf, ctx) {}
function PanelMenu_ng_container_0_div_1_a_5_ng_container_1_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, PanelMenu_ng_container_0_div_1_a_5_ng_container_1_2_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function PanelMenu_ng_container_0_div_1_a_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PanelMenu_ng_container_0_div_1_a_5_ng_container_1_ng_container_1_Template, 3, 2, "ng-container", 7)(2, PanelMenu_ng_container_0_div_1_a_5_ng_container_1_2_Template, 1, 0, null, 16);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r4.headerIconTemplate && !ctx_r4._headerIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r4.headerIconTemplate || ctx_r4._headerIconTemplate);
  }
}
function PanelMenu_ng_container_0_div_1_a_5_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 4);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    const item_r3 = ctx_r1.$implicit;
    const i_r4 = ctx_r1.index;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r4.cn(ctx_r4.cx("headerIcon"), item_r3.icon, ctx_r4.getItemProp(item_r3, "iconClass")));
    i0.ɵɵproperty("ngStyle", ctx_r4.getItemProp(item_r3, "iconStyle"))("pBind", ctx_r4.getPTOptions("headerIcon", item_r3, i_r4));
  }
}
function PanelMenu_ng_container_0_div_1_a_5_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    const item_r3 = ctx_r1.$implicit;
    const i_r4 = ctx_r1.index;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r4.cn(ctx_r4.cx("headerLabel"), ctx_r4.getItemProp(item_r3, "labelClass")));
    i0.ɵɵproperty("ngStyle", ctx_r4.getItemProp(item_r3, "labelStyle"))("pBind", ctx_r4.getPTOptions("headerLabel", item_r3, i_r4));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r4.getItemProp(item_r3, "label"));
  }
}
function PanelMenu_ng_container_0_div_1_a_5_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 21);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    const item_r3 = ctx_r1.$implicit;
    const i_r4 = ctx_r1.index;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r4.cn(ctx_r4.cx("headerLabel"), ctx_r4.getItemProp(item_r3, "labelClass")));
    i0.ɵɵproperty("ngStyle", ctx_r4.getItemProp(item_r3, "labelStyle"))("innerHTML", ctx_r4.getItemProp(item_r3, "label"), i0.ɵɵsanitizeHtml)("pBind", ctx_r4.getPTOptions("headerLabel", item_r3, i_r4));
  }
}
function PanelMenu_ng_container_0_div_1_a_5_span_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r4.cn(ctx_r4.cx("badge"), ctx_r4.getItemProp(item_r3, "badgeStyleClass")));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r4.getItemProp(item_r3, "badge"));
  }
}
function PanelMenu_ng_container_0_div_1_a_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 22);
    i0.ɵɵtemplate(1, PanelMenu_ng_container_0_div_1_a_5_ng_container_1_Template, 3, 2, "ng-container", 7)(2, PanelMenu_ng_container_0_div_1_a_5_span_2_Template, 1, 4, "span", 3)(3, PanelMenu_ng_container_0_div_1_a_5_span_3_Template, 2, 5, "span", 14)(4, PanelMenu_ng_container_0_div_1_a_5_ng_template_4_Template, 1, 5, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(6, PanelMenu_ng_container_0_div_1_a_5_span_6_Template, 2, 3, "span", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const htmlRouteLabel_r7 = i0.ɵɵreference(5);
    const ctx_r1 = i0.ɵɵnextContext(2);
    const item_r3 = ctx_r1.$implicit;
    const i_r4 = ctx_r1.index;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r4.cn(ctx_r4.cx("headerLink"), ctx_r4.getItemProp(item_r3, "linkClass")));
    i0.ɵɵproperty("routerLink", ctx_r4.getItemProp(item_r3, "routerLink"))("queryParams", ctx_r4.getItemProp(item_r3, "queryParams"))("routerLinkActive", "p-panelmenu-item-link-active")("routerLinkActiveOptions", ctx_r4.getItemProp(item_r3, "routerLinkActiveOptions") || i0.ɵɵpureFunction0(23, _c2))("target", ctx_r4.getItemProp(item_r3, "target"))("ngStyle", ctx_r4.getItemProp(item_r3, "linkStyle"))("fragment", ctx_r4.getItemProp(item_r3, "fragment"))("queryParamsHandling", ctx_r4.getItemProp(item_r3, "queryParamsHandling"))("preserveFragment", ctx_r4.getItemProp(item_r3, "preserveFragment"))("skipLocationChange", ctx_r4.getItemProp(item_r3, "skipLocationChange"))("replaceUrl", ctx_r4.getItemProp(item_r3, "replaceUrl"))("state", ctx_r4.getItemProp(item_r3, "state"))("pBind", ctx_r4.getPTOptions("headerLink", item_r3, i_r4));
    i0.ɵɵattribute("title", ctx_r4.getItemProp(item_r3, "title"))("data-automationid", ctx_r4.getItemProp(item_r3, "automationId"))("tabindex", -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.isItemGroup(item_r3));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r3.icon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.getItemProp(item_r3, "escape") !== false)("ngIfElse", htmlRouteLabel_r7);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r4.getItemProp(item_r3, "badge"));
  }
}
function PanelMenu_ng_container_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "div", 5);
    i0.ɵɵlistener("click", function PanelMenu_ng_container_0_div_1_Template_div_click_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      const item_r3 = ctx_r1.$implicit;
      const i_r4 = ctx_r1.index;
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.onHeaderClick($event, item_r3, i_r4));
    })("keydown", function PanelMenu_ng_container_0_div_1_Template_div_keydown_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      const item_r3 = ctx_r1.$implicit;
      const i_r4 = ctx_r1.index;
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.onHeaderKeyDown($event, item_r3, i_r4));
    });
    i0.ɵɵelementStart(2, "div", 6);
    i0.ɵɵtemplate(3, PanelMenu_ng_container_0_div_1_ng_container_3_Template, 2, 1, "ng-container", 7)(4, PanelMenu_ng_container_0_div_1_ng_container_4_Template, 1, 0, "ng-container", 8)(5, PanelMenu_ng_container_0_div_1_a_5_Template, 7, 24, "a", 9);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 10)(7, "div", 6)(8, "div", 6)(9, "ul", 11);
    i0.ɵɵlistener("headerFocus", function PanelMenu_ng_container_0_div_1_Template_ul_headerFocus_9_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r4 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r4.updateFocusedHeader($event));
    });
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const item_r3 = ctx_r1.$implicit;
    const i_r4 = ctx_r1.index;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r4.cn(ctx_r4.cx("panel"), ctx_r4.getItemProp(item_r3, "headerClass")));
    i0.ɵɵproperty("ngStyle", ctx_r4.getItemProp(item_r3, "style"))("pBind", ctx_r4.ptm("panel"));
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r4.cn(ctx_r4.cx("header", i0.ɵɵpureFunction1(50, _c10, item_r3)), ctx_r4.getItemProp(item_r3, "styleClass")));
    i0.ɵɵproperty("ngStyle", ctx_r4.getItemProp(item_r3, "style"))("pTooltip", ctx_r4.getItemProp(item_r3, "tooltip"))("pTooltipUnstyled", ctx_r4.unstyled())("tabindex", 0)("tooltipOptions", ctx_r4.getItemProp(item_r3, "tooltipOptions"))("pBind", ctx_r4.getPTOptions("header", item_r3, i_r4));
    i0.ɵɵattribute("id", ctx_r4.getHeaderId(item_r3, i_r4))("aria-expanded", ctx_r4.isItemActive(item_r3))("aria-label", ctx_r4.getItemProp(item_r3, "label"))("aria-controls", ctx_r4.getContentId(item_r3, i_r4))("aria-disabled", ctx_r4.isItemDisabled(item_r3))("data-p-highlight", ctx_r4.isItemActive(item_r3))("data-p-disabled", ctx_r4.isItemDisabled(item_r3));
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r4.cx("headerContent"));
    i0.ɵɵproperty("pBind", ctx_r4.getPTOptions("headerContent", item_r3, i_r4));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r4.itemTemplate && !ctx_r4._itemTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r4.itemTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(52, _c3, item_r3));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.getItemProp(item_r3, "routerLink"));
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r4.cx("contentContainer", i0.ɵɵpureFunction1(54, _c1, item_r3)));
    i0.ɵɵproperty("pBind", ctx_r4.ptm("contentContainer"))("pMotion", ctx_r4.isItemActive(item_r3))("pMotionOptions", ctx_r4.computedMotionOptions());
    i0.ɵɵattribute("id", ctx_r4.getContentId(item_r3, i_r4))("aria-labelledby", ctx_r4.getHeaderId(item_r3, i_r4));
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r4.cx("contentWrapper"));
    i0.ɵɵproperty("pBind", ctx_r4.ptm("contentWrapper"));
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r4.cx("content"));
    i0.ɵɵproperty("pBind", ctx_r4.ptm("content"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("panelId", ctx_r4.getPanelId(i_r4, item_r3))("items", ctx_r4.getItemProp(item_r3, "items"))("itemTemplate", ctx_r4.itemTemplate || ctx_r4._itemTemplate)("transitionOptions", ctx_r4.transitionOptions)("root", true)("activeItem", ctx_r4.activeItem())("tabindex", ctx_r4.tabindex)("parentExpanded", ctx_r4.isItemActive(item_r3))("pt", ctx_r4.pt())("unstyled", ctx_r4.unstyled())("motionOptions", ctx_r4.computedMotionOptions());
  }
}
function PanelMenu_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PanelMenu_ng_container_0_div_1_Template, 10, 56, "div", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r3 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.isItemVisible(item_r3));
  }
}
export * from 'primeng/types/panelmenu';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, InjectionToken, input, EventEmitter, inject, ElementRef, forwardRef, booleanAttribute, numberAttribute, Output, Input, ViewEncapsulation, Component, signal, computed, ViewChild, ChangeDetectionStrategy, ContentChildren, ContentChild, NgModule } from '@angular/core';
import * as i3 from '@angular/router';
import { RouterModule } from '@angular/router';
import { resolve, isNotEmpty, findLast, findSingle, isPrintableCharacter, isEmpty, uuid, equals, focus, getAttribute } from '@primeuix/utils';
import { SharedModule, PrimeTemplate } from 'primeng/api';
import { BaseComponent, PARENT_INSTANCE } from 'primeng/basecomponent';
import * as i1 from 'primeng/bind';
import { Bind, BindModule } from 'primeng/bind';
import { ChevronDownIcon, ChevronRightIcon } from 'primeng/icons';
import * as i5 from 'primeng/motion';
import { MotionModule } from 'primeng/motion';
import * as i4 from 'primeng/tooltip';
import { TooltipModule } from 'primeng/tooltip';
import { style as style$1 } from '@primeuix/styles/panelmenu';
import { BaseStyle } from 'primeng/base';
const style = /*css*/`
    ${style$1}
    /*For PrimeNG*/


    .p-panelmenu-root-list,
    .p-panelmenu-submenu,
    .p-panelmenu-item-link {
        outline: 0 none;
    }
`;
const classes = {
  root: () => ['p-panelmenu p-component'],
  panel: 'p-panelmenu-panel',
  header: ({
    instance,
    item
  }) => ['p-panelmenu-header', {
    'p-panelmenu-header-active': instance.isItemActive(item) && !!item.items,
    'p-disabled': instance.isItemDisabled(item)
  }],
  headerContent: 'p-panelmenu-header-content',
  headerLink: 'p-panelmenu-header-link',
  headerIcon: 'p-panelmenu-header-icon',
  headerLabel: 'p-panelmenu-header-label',
  contentContainer: ({
    instance,
    processedItem
  }) => ['p-panelmenu-content-container', {
    'p-panelmenu-expanded': instance.isItemActive(processedItem)
  }],
  contentWrapper: 'p-panelmenu-content-wrapper',
  content: 'p-panelmenu-content',
  rootList: 'p-panelmenu-root-list',
  item: ({
    instance,
    processedItem
  }) => ['p-panelmenu-item', {
    'p-focus': instance.isItemFocused(processedItem) && !instance.isItemDisabled(processedItem),
    'p-disabled': instance.isItemDisabled(processedItem)
  }],
  itemContent: 'p-panelmenu-item-content',
  itemLink: 'p-panelmenu-item-link',
  itemIcon: 'p-panelmenu-item-icon',
  itemLabel: 'p-panelmenu-item-label',
  submenuIcon: 'p-panelmenu-submenu-icon',
  submenu: 'p-panelmenu-submenu',
  separator: 'p-menuitem-separator',
  badge: 'p-menuitem-badge'
};
let PanelMenuStyle = /*#__PURE__*/(() => {
  class PanelMenuStyle extends BaseStyle {
    name = 'panelmenu';
    style = style;
    classes = classes;
    static ɵfac = /* @__PURE__ */(() => {
      let ɵPanelMenuStyle_BaseFactory;
      return function PanelMenuStyle_Factory(__ngFactoryType__) {
        return (ɵPanelMenuStyle_BaseFactory || (ɵPanelMenuStyle_BaseFactory = i0.ɵɵgetInheritedFactory(PanelMenuStyle)))(__ngFactoryType__ || PanelMenuStyle);
      };
    })();
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: PanelMenuStyle,
      factory: PanelMenuStyle.ɵfac
    });
  }
  return PanelMenuStyle;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 *
 * PanelMenu is a hybrid of Accordion and Tree components.
 *
 * [Live Demo](https://www.primeng.org/panelmenu/)
 *
 * @module panelmenustyle
 *
 */
var PanelMenuClasses = /*#__PURE__*/function (PanelMenuClasses) {
  /**
   * Class name of the root element
   */
  PanelMenuClasses["root"] = "p-panelmenu";
  /**
   * Class name of the panel element
   */
  PanelMenuClasses["panel"] = "p-panelmenu-panel";
  /**
   * Class name of the header element
   */
  PanelMenuClasses["header"] = "p-panelmenu-header";
  /**
   * Class name of the header content element
   */
  PanelMenuClasses["headerContent"] = "p-panelmenu-header-content";
  /**
   * Class name of the header link element
   */
  PanelMenuClasses["headerLink"] = "p-panelmenu-header-link";
  /**
   * Class name of the header icon element
   */
  PanelMenuClasses["headerIcon"] = "p-panelmenu-header-icon";
  /**
   * Class name of the header label element
   */
  PanelMenuClasses["headerLabel"] = "p-panelmenu-header-label";
  /**
   * Class name of the content container element
   */
  PanelMenuClasses["contentContainer"] = "p-panelmenu-content-container";
  /**
   * Class name of the content element
   */
  PanelMenuClasses["content"] = "p-panelmenu-content";
  /**
   * Class name of the root list element
   */
  PanelMenuClasses["rootList"] = "p-panelmenu-root-list";
  /**
   * Class name of the item element
   */
  PanelMenuClasses["item"] = "p-panelmenu-item";
  /**
   * Class name of the item content element
   */
  PanelMenuClasses["itemContent"] = "p-panelmenu-item-content";
  /**
   * Class name of the item link element
   */
  PanelMenuClasses["itemLink"] = "p-panelmenu-item-link";
  /**
   * Class name of the item icon element
   */
  PanelMenuClasses["itemIcon"] = "p-panelmenu-item-icon";
  /**
   * Class name of the item label element
   */
  PanelMenuClasses["itemLabel"] = "p-panelmenu-item-label";
  /**
   * Class name of the submenu icon element
   */
  PanelMenuClasses["submenuIcon"] = "p-panelmenu-submenu-icon";
  /**
   * Class name of the submenu element
   */
  PanelMenuClasses["submenu"] = "p-panelmenu-submenu";
  PanelMenuClasses["separator"] = "p-menuitem-separator";
  return PanelMenuClasses;
}(PanelMenuClasses || {});
const PANELMENU_INSTANCE = /*#__PURE__*/new InjectionToken('PANELMENU_INSTANCE');
const PANELMENUSUB_INSTANCE = /*#__PURE__*/new InjectionToken('PANELMENUSUB_INSTANCE');
let PanelMenuSub = /*#__PURE__*/(() => {
  class PanelMenuSub extends BaseComponent {
    panelId;
    focusedItemId;
    items;
    itemTemplate;
    level = 0;
    activeItemPath;
    root;
    tabindex;
    transitionOptions;
    parentExpanded;
    motionOptions = input(...(ngDevMode ? [undefined, {
      debugName: "motionOptions"
    }] : []));
    itemToggle = new EventEmitter();
    menuFocus = new EventEmitter();
    menuBlur = new EventEmitter();
    menuKeyDown = new EventEmitter();
    listViewChild = inject(ElementRef);
    panelMenu = inject(forwardRef(() => PanelMenu));
    _componentStyle = inject(PanelMenuStyle);
    bindDirectiveInstance = inject(Bind, {
      self: true
    });
    $pcPanelMenu = inject(PANELMENU_INSTANCE, {
      optional: true,
      skipSelf: true
    }) ?? undefined;
    onAfterViewChecked() {
      this.bindDirectiveInstance.setAttrs(this.ptm(this.root ? 'rootList' : 'submenu'));
    }
    getPTOptions(processedItem, index, key) {
      return this.ptm(key, {
        context: {
          item: processedItem.item,
          index,
          active: this.isItemActive(processedItem),
          focused: this.isItemFocused(processedItem),
          disabled: this.isItemDisabled(processedItem)
        }
      });
    }
    getItemId(processedItem) {
      return processedItem.item?.id ?? `${this.panelId}_${processedItem.key}`;
    }
    getItemKey(processedItem) {
      return this.getItemId(processedItem);
    }
    getItemClass(processedItem) {
      return {
        'p-panelmenu-item': true,
        'p-disabled': this.isItemDisabled(processedItem),
        'p-focus': this.isItemFocused(processedItem)
      };
    }
    getItemProp(processedItem, name, params) {
      return processedItem && processedItem.item ? resolve(processedItem.item[name], params) : undefined;
    }
    getItemLabel(processedItem) {
      return this.getItemProp(processedItem, 'label');
    }
    isItemExpanded(processedItem) {
      return processedItem.expanded;
    }
    isItemActive(processedItem) {
      return this.isItemExpanded(processedItem) || this.activeItemPath.some(path => path && path.key === processedItem.key);
    }
    isItemVisible(processedItem) {
      return this.getItemProp(processedItem, 'visible') !== false;
    }
    isItemDisabled(processedItem) {
      return this.getItemProp(processedItem, 'disabled');
    }
    isItemFocused(processedItem) {
      return this.focusedItemId === this.getItemId(processedItem);
    }
    isItemGroup(processedItem) {
      return isNotEmpty(processedItem.items);
    }
    getAriaSetSize() {
      return this.items.filter(processedItem => this.isItemVisible(processedItem) && !this.getItemProp(processedItem, 'separator')).length;
    }
    getAriaPosInset(index) {
      return index - this.items.slice(0, index).filter(processedItem => this.isItemVisible(processedItem) && this.getItemProp(processedItem, 'separator')).length + 1;
    }
    onItemClick(event, processedItem) {
      if (!this.isItemDisabled(processedItem)) {
        this.getItemProp(processedItem, 'command', {
          originalEvent: event,
          item: processedItem.item
        });
        this.itemToggle.emit({
          processedItem,
          expanded: !this.isItemActive(processedItem)
        });
      }
    }
    onItemToggle(event) {
      this.itemToggle.emit(event);
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵPanelMenuSub_BaseFactory;
      return function PanelMenuSub_Factory(__ngFactoryType__) {
        return (ɵPanelMenuSub_BaseFactory || (ɵPanelMenuSub_BaseFactory = i0.ɵɵgetInheritedFactory(PanelMenuSub)))(__ngFactoryType__ || PanelMenuSub);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: PanelMenuSub,
      selectors: [["ul", "pPanelMenuSub", ""]],
      hostAttrs: ["role", "tree"],
      hostVars: 5,
      hostBindings: function PanelMenuSub_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("focusin", function PanelMenuSub_focusin_HostBindingHandler($event) {
            return ctx.menuFocus.emit($event);
          })("focusout", function PanelMenuSub_focusout_HostBindingHandler($event) {
            return ctx.menuBlur.emit($event);
          })("keydown", function PanelMenuSub_keydown_HostBindingHandler($event) {
            return ctx.menuKeyDown.emit($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵdomProperty("tabIndex", -1);
          i0.ɵɵattribute("aria-activedescendant", ctx.focusedItemId)("aria-hidden", !ctx.parentExpanded);
          i0.ɵɵclassMap(ctx.root ? ctx.cn(ctx.cx("rootList"), ctx.cx("submenu")) : ctx.cx("submenu"));
        }
      },
      inputs: {
        panelId: "panelId",
        focusedItemId: "focusedItemId",
        items: "items",
        itemTemplate: "itemTemplate",
        level: [2, "level", "level", numberAttribute],
        activeItemPath: "activeItemPath",
        root: [2, "root", "root", booleanAttribute],
        tabindex: [2, "tabindex", "tabindex", numberAttribute],
        transitionOptions: "transitionOptions",
        parentExpanded: [2, "parentExpanded", "parentExpanded", booleanAttribute],
        motionOptions: [1, "motionOptions"]
      },
      outputs: {
        itemToggle: "itemToggle",
        menuFocus: "menuFocus",
        menuBlur: "menuBlur",
        menuKeyDown: "menuKeyDown"
      },
      features: [i0.ɵɵProvidersFeature([PanelMenuStyle, {
        provide: PANELMENUSUB_INSTANCE,
        useExisting: PanelMenuSub
      }, {
        provide: PARENT_INSTANCE,
        useExisting: PanelMenuSub
      }]), i0.ɵɵHostDirectivesFeature([i1.Bind]), i0.ɵɵInheritDefinitionFeature],
      attrs: _c0,
      decls: 1,
      vars: 1,
      consts: [["htmlLabel", ""], ["ngFor", "", 3, "ngForOf"], ["role", "separator", 3, "class", "pBind", 4, "ngIf"], ["role", "treeitem", 3, "class", "ngStyle", "pTooltip", "pTooltipUnstyled", "pBind", "tooltipOptions", 4, "ngIf"], ["role", "separator", 3, "pBind"], ["role", "treeitem", 3, "ngStyle", "pTooltip", "pTooltipUnstyled", "pBind", "tooltipOptions"], [3, "click", "pBind"], [4, "ngIf"], ["pMotionName", "p-collapsible", 3, "pMotion", "pMotionOptions"], [3, "pBind"], ["pPanelMenuSub", "", 3, "itemToggle", "id", "panelId", "items", "itemTemplate", "transitionOptions", "focusedItemId", "activeItemPath", "level", "pt", "unstyled", "parentExpanded", "motionOptions"], [3, "class", "ngStyle", "target", "pBind", 4, "ngIf"], [3, "routerLink", "queryParams", "routerLinkActive", "routerLinkActiveOptions", "class", "ngStyle", "target", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "pBind", 4, "ngIf"], [3, "ngStyle", "target", "pBind"], [3, "class", "ngStyle", "pBind", 4, "ngIf"], [3, "class", "ngStyle", "pBind", 4, "ngIf", "ngIfElse"], [4, "ngTemplateOutlet"], ["data-p-icon", "chevron-down", 3, "class", "ngStyle", "pBind", 4, "ngIf"], ["data-p-icon", "chevron-right", 3, "class", "ngStyle", "pBind", 4, "ngIf"], ["data-p-icon", "chevron-down", 3, "ngStyle", "pBind"], ["data-p-icon", "chevron-right", 3, "ngStyle", "pBind"], [3, "ngStyle", "pBind"], [3, "ngStyle", "innerHTML", "pBind"], [3, "routerLink", "queryParams", "routerLinkActive", "routerLinkActiveOptions", "ngStyle", "target", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "pBind"], [3, "class", "ngStyle", "innerHTML", "pBind", 4, "ngIf"], [3, "class", 4, "ngIf"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]],
      template: function PanelMenuSub_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, PanelMenuSub_ng_template_0_Template, 2, 2, "ng-template", 1);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngForOf", ctx.items);
        }
      },
      dependencies: [PanelMenuSub, CommonModule, i2.NgForOf, i2.NgIf, i2.NgTemplateOutlet, i2.NgStyle, RouterModule, i3.RouterLink, i3.RouterLinkActive, TooltipModule, i4.Tooltip, i1.Bind, ChevronDownIcon, ChevronRightIcon, SharedModule, BindModule, MotionModule, i5.MotionDirective],
      encapsulation: 2
    });
  }
  return PanelMenuSub;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PanelMenuList = /*#__PURE__*/(() => {
  class PanelMenuList extends BaseComponent {
    panelId;
    id;
    items;
    itemTemplate;
    parentExpanded;
    expanded;
    transitionOptions;
    root;
    tabindex;
    activeItem;
    motionOptions = input(...(ngDevMode ? [undefined, {
      debugName: "motionOptions"
    }] : []));
    itemToggle = new EventEmitter();
    headerFocus = new EventEmitter();
    subMenuViewChild;
    searchTimeout;
    searchValue;
    focused;
    focusedItem = signal(null, ...(ngDevMode ? [{
      debugName: "focusedItem"
    }] : []));
    activeItemPath = signal([], ...(ngDevMode ? [{
      debugName: "activeItemPath"
    }] : []));
    processedItems = signal([], ...(ngDevMode ? [{
      debugName: "processedItems"
    }] : []));
    visibleItems = computed(() => {
      const processedItems = this.processedItems();
      return this.flatItems(processedItems);
    }, ...(ngDevMode ? [{
      debugName: "visibleItems"
    }] : []));
    get focusedItemId() {
      const focusedItem = this.focusedItem();
      return focusedItem && focusedItem.item?.id ? focusedItem.item.id : isNotEmpty(this.focusedItem()) ? `${this.panelId}_${this.focusedItem().key}` : undefined;
    }
    onChanges(changes) {
      this.processedItems.set(this.createProcessedItems(changes?.items?.currentValue || this.items || []));
    }
    getItemProp(processedItem, name) {
      return processedItem && processedItem.item ? resolve(processedItem.item[name]) : undefined;
    }
    getItemLabel(processedItem) {
      return this.getItemProp(processedItem, 'label');
    }
    isItemVisible(processedItem) {
      return this.getItemProp(processedItem, 'visible') !== false;
    }
    isItemDisabled(processedItem) {
      return this.getItemProp(processedItem, 'disabled');
    }
    isItemActive(processedItem) {
      return this.activeItemPath().some(path => path.key === processedItem.parentKey);
    }
    isItemGroup(processedItem) {
      return isNotEmpty(processedItem.items);
    }
    isElementInPanel(event, element) {
      const panel = event.currentTarget.closest('[data-pc-name="panelmenu"]');
      return panel && panel.contains(element);
    }
    isItemMatched(processedItem) {
      return this.isValidItem(processedItem) && this.getItemLabel(processedItem).toLocaleLowerCase().startsWith(this.searchValue.toLocaleLowerCase());
    }
    isVisibleItem(processedItem) {
      return !!processedItem && (processedItem.level === 0 || this.isItemActive(processedItem)) && this.isItemVisible(processedItem);
    }
    isValidItem(processedItem) {
      return !!processedItem && !this.isItemDisabled(processedItem) && !processedItem.separator;
    }
    findFirstItem() {
      return this.visibleItems().find(processedItem => this.isValidItem(processedItem));
    }
    findLastItem() {
      return findLast(this.visibleItems(), processedItem => this.isValidItem(processedItem));
    }
    findItemByEventTarget(target) {
      let parentNode = target;
      while (parentNode && parentNode.tagName?.toLowerCase() !== 'li') {
        parentNode = parentNode?.parentNode;
      }
      return parentNode?.id && this.visibleItems().find(processedItem => this.isValidItem(processedItem) && `${this.panelId}_${processedItem.key}` === parentNode.id);
    }
    createProcessedItems(items, level = 0, parent = {}, parentKey = '') {
      const processedItems = [];
      items && items.forEach((item, index) => {
        const key = (parentKey !== '' ? parentKey + '_' : '') + index;
        const newItem = {
          icon: item.icon,
          expanded: item.expanded,
          separator: item.separator,
          item,
          index,
          level,
          key,
          parent,
          parentKey
        };
        newItem['items'] = this.createProcessedItems(item.items, level + 1, newItem, key);
        processedItems.push(newItem);
      });
      return processedItems;
    }
    findProcessedItemByItemKey(key, processedItems, level = 0) {
      processedItems = processedItems || this.processedItems();
      if (processedItems && processedItems.length) {
        for (let i = 0; i < processedItems.length; i++) {
          const processedItem = processedItems[i];
          if (this.getItemProp(processedItem, 'key') === key) return processedItem;
          const matchedItem = this.findProcessedItemByItemKey(key, processedItem.items, level + 1);
          if (matchedItem) return matchedItem;
        }
      }
    }
    flatItems(processedItems, processedFlattenItems = []) {
      processedItems && processedItems.forEach(processedItem => {
        if (this.isVisibleItem(processedItem)) {
          processedFlattenItems.push(processedItem);
          this.flatItems(processedItem.items, processedFlattenItems);
        }
      });
      return processedFlattenItems;
    }
    changeFocusedItem(event) {
      const {
        originalEvent,
        processedItem,
        focusOnNext,
        selfCheck,
        allowHeaderFocus = true
      } = event;
      if (isNotEmpty(this.focusedItem()) && this.focusedItem().key !== processedItem.key) {
        this.focusedItem.set(processedItem);
        this.scrollInView();
      } else if (allowHeaderFocus) {
        this.headerFocus.emit({
          originalEvent,
          focusOnNext,
          selfCheck
        });
      }
    }
    scrollInView() {
      const element = findSingle(this.subMenuViewChild.listViewChild.nativeElement, `li[id="${`${this.focusedItemId}`}"]`);
      if (element) {
        element.scrollIntoView && element.scrollIntoView({
          block: 'nearest',
          inline: 'nearest'
        });
      }
    }
    onFocus(event) {
      if (!this.focused) {
        this.focused = true;
        const focusedItem = this.focusedItem() || (this.isElementInPanel(event, event.relatedTarget) ? this.findItemByEventTarget(event.target) || this.findFirstItem() : this.findLastItem());
        if (event.relatedTarget !== null) this.focusedItem.set(focusedItem);
      }
    }
    onBlur(event) {
      const target = event.relatedTarget;
      if (this.focused && !this.el.nativeElement.contains(target)) {
        this.focused = false;
        this.focusedItem.set(null);
        this.searchValue = '';
      }
    }
    onItemToggle(event) {
      const {
        processedItem,
        expanded
      } = event;
      // Update the original item object's 'expanded' property
      if (processedItem.item) {
        processedItem.item.expanded = expanded;
      }
      // Update the expanded property in the existing processedItem
      processedItem.expanded = expanded;
      // Trigger signal update without recreating the entire tree
      this.processedItems.update(items => [...items]);
      // Update activeItemPath
      const activeItemPath = this.activeItemPath().filter(p => p.parentKey !== processedItem.parentKey);
      if (expanded) {
        activeItemPath.push(processedItem);
      }
      this.activeItemPath.set(activeItemPath);
      // Update focusedItem
      this.focusedItem.set(processedItem);
    }
    onKeyDown(event) {
      const metaKey = event.metaKey || event.ctrlKey;
      switch (event.code) {
        case 'ArrowDown':
          this.onArrowDownKey(event);
          break;
        case 'ArrowUp':
          this.onArrowUpKey(event);
          break;
        case 'ArrowLeft':
          this.onArrowLeftKey(event);
          break;
        case 'ArrowRight':
          this.onArrowRightKey(event);
          break;
        case 'Home':
          this.onHomeKey(event);
          break;
        case 'End':
          this.onEndKey(event);
          break;
        case 'Space':
          this.onSpaceKey(event);
          break;
        case 'Enter':
          this.onEnterKey(event);
          break;
        case 'Escape':
        case 'Tab':
        case 'PageDown':
        case 'PageUp':
        case 'Backspace':
        case 'ShiftLeft':
        case 'ShiftRight':
          //NOOP
          break;
        default:
          if (!metaKey && isPrintableCharacter(event.key)) {
            this.searchItems(event, event.key);
          }
          break;
      }
    }
    onArrowDownKey(event) {
      const processedItem = isNotEmpty(this.focusedItem()) ? this.findNextItem(this.focusedItem()) : this.findFirstItem();
      this.changeFocusedItem({
        originalEvent: event,
        processedItem,
        focusOnNext: true
      });
      event.preventDefault();
    }
    onArrowUpKey(event) {
      const processedItem = isNotEmpty(this.focusedItem()) ? this.findPrevItem(this.focusedItem()) : this.findLastItem();
      this.changeFocusedItem({
        originalEvent: event,
        processedItem,
        selfCheck: true
      });
      event.preventDefault();
    }
    onArrowLeftKey(event) {
      if (isNotEmpty(this.focusedItem())) {
        const matched = this.activeItemPath().some(p => p.key === this.focusedItem().key);
        if (matched) {
          const activeItemPath = this.activeItemPath().filter(p => p.key !== this.focusedItem().key);
          this.activeItemPath.set(activeItemPath);
        } else {
          const focusedItem = isNotEmpty(this.focusedItem().parent) ? this.focusedItem().parent : this.focusedItem();
          this.focusedItem.set(focusedItem);
        }
        event.preventDefault();
      }
    }
    onArrowRightKey(event) {
      if (isNotEmpty(this.focusedItem())) {
        const grouped = this.isItemGroup(this.focusedItem());
        if (grouped) {
          const matched = this.activeItemPath().some(p => p.key === this.focusedItem().key);
          if (matched) {
            this.onArrowDownKey(event);
          } else {
            const activeItemPath = this.activeItemPath().filter(p => p.parentKey !== this.focusedItem().parentKey);
            activeItemPath.push(this.focusedItem());
            this.activeItemPath.set(activeItemPath);
          }
        }
        event.preventDefault();
      }
    }
    onHomeKey(event) {
      this.changeFocusedItem({
        originalEvent: event,
        processedItem: this.findFirstItem(),
        allowHeaderFocus: false
      });
      event.preventDefault();
    }
    onEndKey(event) {
      this.changeFocusedItem({
        originalEvent: event,
        processedItem: this.findLastItem(),
        focusOnNext: true,
        allowHeaderFocus: false
      });
      event.preventDefault();
    }
    onEnterKey(event) {
      if (isNotEmpty(this.focusedItem())) {
        const element = findSingle(this.subMenuViewChild.listViewChild.nativeElement, `li[id="${`${this.focusedItemId}`}"]`);
        const anchorElement = element && (findSingle(element, 'a') || findSingle(element, 'button'));
        anchorElement ? anchorElement.click() : element && element.click();
      }
      event.preventDefault();
    }
    onSpaceKey(event) {
      this.onEnterKey(event);
    }
    findNextItem(processedItem) {
      const index = this.visibleItems().findIndex(item => item.key === processedItem.key);
      const matchedItem = index < this.visibleItems().length - 1 ? this.visibleItems().slice(index + 1).find(pItem => this.isValidItem(pItem)) : undefined;
      return matchedItem || processedItem;
    }
    findPrevItem(processedItem) {
      const index = this.visibleItems().findIndex(item => item.key === processedItem.key);
      const matchedItem = index > 0 ? findLast(this.visibleItems().slice(0, index), pItem => this.isValidItem(pItem)) : undefined;
      return matchedItem || processedItem;
    }
    searchItems(event, char) {
      this.searchValue = (this.searchValue || '') + char;
      let matchedItem = null;
      let matched = false;
      if (isNotEmpty(this.focusedItem())) {
        const focusedItemIndex = this.visibleItems().findIndex(processedItem => processedItem.key === this.focusedItem().key);
        matchedItem = this.visibleItems().slice(focusedItemIndex).find(processedItem => this.isItemMatched(processedItem)) || null;
        matchedItem = isEmpty(matchedItem) ? this.visibleItems().slice(0, focusedItemIndex).find(processedItem => this.isItemMatched(processedItem)) || null : matchedItem;
      } else {
        matchedItem = this.visibleItems().find(processedItem => this.isItemMatched(processedItem)) || null;
      }
      if (isNotEmpty(matchedItem)) {
        matched = true;
      }
      if (isEmpty(matchedItem) && isEmpty(this.focusedItem())) {
        matchedItem = this.findFirstItem() || null;
      }
      if (isNotEmpty(matchedItem)) {
        this.changeFocusedItem({
          originalEvent: event,
          processedItem: matchedItem,
          allowHeaderFocus: false
        });
      }
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        this.searchValue = '';
        this.searchTimeout = null;
      }, 500);
      return matched;
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵPanelMenuList_BaseFactory;
      return function PanelMenuList_Factory(__ngFactoryType__) {
        return (ɵPanelMenuList_BaseFactory || (ɵPanelMenuList_BaseFactory = i0.ɵɵgetInheritedFactory(PanelMenuList)))(__ngFactoryType__ || PanelMenuList);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: PanelMenuList,
      selectors: [["ul", "pPanelMenuList", ""]],
      viewQuery: function PanelMenuList_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c4, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.subMenuViewChild = _t.first);
        }
      },
      inputs: {
        panelId: "panelId",
        id: "id",
        items: "items",
        itemTemplate: "itemTemplate",
        parentExpanded: [2, "parentExpanded", "parentExpanded", booleanAttribute],
        expanded: [2, "expanded", "expanded", booleanAttribute],
        transitionOptions: "transitionOptions",
        root: [2, "root", "root", booleanAttribute],
        tabindex: [2, "tabindex", "tabindex", numberAttribute],
        activeItem: "activeItem",
        motionOptions: [1, "motionOptions"]
      },
      outputs: {
        itemToggle: "itemToggle",
        headerFocus: "headerFocus"
      },
      features: [i0.ɵɵInheritDefinitionFeature],
      attrs: _c5,
      decls: 2,
      vars: 13,
      consts: [["submenu", ""], ["pPanelMenuSub", "", 3, "itemToggle", "keydown", "menuFocus", "menuBlur", "root", "id", "panelId", "tabindex", "itemTemplate", "focusedItemId", "activeItemPath", "transitionOptions", "items", "parentExpanded", "pt", "unstyled", "motionOptions"]],
      template: function PanelMenuList_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "ul", 1, 0);
          i0.ɵɵlistener("itemToggle", function PanelMenuList_Template_ul_itemToggle_0_listener($event) {
            return ctx.onItemToggle($event);
          })("keydown", function PanelMenuList_Template_ul_keydown_0_listener($event) {
            return ctx.onKeyDown($event);
          })("menuFocus", function PanelMenuList_Template_ul_menuFocus_0_listener($event) {
            return ctx.onFocus($event);
          })("menuBlur", function PanelMenuList_Template_ul_menuBlur_0_listener($event) {
            return ctx.onBlur($event);
          });
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("root", ctx.root)("id", ctx.panelId + "_list")("panelId", ctx.panelId)("tabindex", ctx.tabindex)("itemTemplate", ctx.itemTemplate)("focusedItemId", ctx.focused ? ctx.focusedItemId : undefined)("activeItemPath", ctx.activeItemPath())("transitionOptions", ctx.transitionOptions)("items", ctx.processedItems())("parentExpanded", ctx.parentExpanded)("pt", ctx.pt())("unstyled", ctx.unstyled())("motionOptions", ctx.motionOptions());
        }
      },
      dependencies: [CommonModule, PanelMenuSub, RouterModule, TooltipModule, SharedModule],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return PanelMenuList;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * PanelMenu is a hybrid of Accordion and Tree components.
 * @group Components
 */
let PanelMenu = /*#__PURE__*/(() => {
  class PanelMenu extends BaseComponent {
    componentName = 'PanelMenu';
    /**
     * An array of menuitems.
     * @group Props
     */
    model;
    /**
     * Style class of the component.
     * @deprecated since v20.0.0, use `class` instead.
     * @group Props
     */
    styleClass;
    /**
     * Whether multiple tabs can be activated at the same time or not.
     * @group Props
     */
    multiple = false;
    /**
     * Transition options of the animation.
     * @group Props
     * @deprecated since v21.0.0, use `motionOptions` instead.
     */
    transitionOptions = '400ms cubic-bezier(0.86, 0, 0.07, 1)';
    /**
     * The motion options.
     * @group Props
     */
    motionOptions = input(undefined, ...(ngDevMode ? [{
      debugName: "motionOptions"
    }] : []));
    computedMotionOptions = computed(() => {
      return {
        ...this.ptm('motion'),
        ...this.motionOptions()
      };
    }, ...(ngDevMode ? [{
      debugName: "computedMotionOptions"
    }] : []));
    /**
     * Current id state as a string.
     * @group Props
     */
    id;
    /**
     * Index of the element in tabbing order.
     * @group Props
     */
    tabindex = 0;
    containerViewChild;
    /**
     * Template option of submenu icon.
     * @group Templates
     */
    submenuIconTemplate;
    /**
     * Template option of header icon.
     * @group Templates
     */
    headerIconTemplate;
    /**
     * Template option of item.
     * @param {PanelMenuItemTemplateContext} context - item context.
     * @see {@link PanelMenuItemTemplateContext}
     * @group Templates
     */
    itemTemplate;
    templates;
    _submenuIconTemplate;
    _headerIconTemplate;
    _itemTemplate;
    activeItem = signal(null, ...(ngDevMode ? [{
      debugName: "activeItem"
    }] : []));
    _componentStyle = inject(PanelMenuStyle);
    bindDirectiveInstance = inject(Bind, {
      self: true
    });
    $pcPanelMenu = inject(PANELMENU_INSTANCE, {
      optional: true,
      skipSelf: true
    }) ?? undefined;
    onAfterViewChecked() {
      this.bindDirectiveInstance.setAttrs(this.ptms(['host', 'root']));
    }
    getPTOptions(key, item, index) {
      return this.ptm(key, {
        context: {
          item: item,
          index,
          active: this.isItemActive(item)
        }
      });
    }
    onInit() {
      this.id = this.id || uuid('pn_id_');
    }
    onAfterContentInit() {
      this.templates?.forEach(item => {
        switch (item.getType()) {
          case 'submenuicon':
            this._submenuIconTemplate = item.template;
            break;
          case 'headericon':
            this._headerIconTemplate = item.template;
            break;
          case 'item':
            this._itemTemplate = item.template;
            break;
          default:
            this._itemTemplate = item.template;
            break;
        }
      });
    }
    /**
     * Collapses open panels.
     * @group Method
     */
    collapseAll() {
      for (let item of this.model) {
        if (item.expanded) {
          item.expanded = false;
        }
      }
      this.cd.detectChanges();
    }
    changeActiveItem(event, item, index, selfActive = false) {
      if (!this.isItemDisabled(item)) {
        const activeItem = selfActive ? item : this.activeItem && equals(item, this.activeItem) ? null : item;
        this.activeItem.set(activeItem);
      }
    }
    getItemProp(item, name) {
      return item ? resolve(item[name]) : undefined;
    }
    getItemLabel(item) {
      return this.getItemProp(item, 'label');
    }
    isItemActive(item) {
      return item.expanded;
    }
    isItemVisible(item) {
      return this.getItemProp(item, 'visible') !== false;
    }
    isItemDisabled(item) {
      return this.getItemProp(item, 'disabled');
    }
    isItemGroup(item) {
      return isNotEmpty(item.items);
    }
    getPanelId(index, item) {
      return item && item.id ? item.id : `${this.id}_${index}`;
    }
    getHeaderId(item, index) {
      return item.id ? item.id + '_header' : `${this.getPanelId(index)}_header`;
    }
    getContentId(item, index) {
      return item.id ? item.id + '_content' : `${this.getPanelId(index)}_content`;
    }
    updateFocusedHeader(event) {
      const {
        originalEvent,
        focusOnNext,
        selfCheck
      } = event;
      const panelElement = originalEvent.currentTarget.closest('[data-pc-section="panel"]');
      const header = selfCheck ? findSingle(panelElement, '[data-pc-section="header"]') : focusOnNext ? this.findNextHeader(panelElement) : this.findPrevHeader(panelElement);
      header ? this.changeFocusedHeader(originalEvent, header) : focusOnNext ? this.onHeaderHomeKey(originalEvent) : this.onHeaderEndKey(originalEvent);
    }
    changeFocusedHeader(event, element) {
      element && focus(element);
    }
    findNextHeader(panelElement, selfCheck = false) {
      const nextPanelElement = selfCheck ? panelElement : panelElement.nextElementSibling;
      const headerElement = findSingle(nextPanelElement, '[data-pc-section="header"]');
      return headerElement ? getAttribute(headerElement, 'data-p-disabled') ? this.findNextHeader(headerElement.parentElement) : headerElement : null;
    }
    findPrevHeader(panelElement, selfCheck = false) {
      const prevPanelElement = selfCheck ? panelElement : panelElement.previousElementSibling;
      const headerElement = findSingle(prevPanelElement, '[data-pc-section="header"]');
      return headerElement ? getAttribute(headerElement, 'data-p-disabled') ? this.findPrevHeader(headerElement.parentElement) : headerElement : null;
    }
    findFirstHeader() {
      return this.containerViewChild?.nativeElement ? this.findNextHeader(this.containerViewChild.nativeElement.firstElementChild, true) : null;
    }
    findLastHeader() {
      return this.containerViewChild?.nativeElement ? this.findPrevHeader(this.containerViewChild.nativeElement.lastElementChild, true) : null;
    }
    onHeaderClick(event, item, index) {
      if (this.isItemDisabled(item)) {
        event.preventDefault();
        return;
      }
      if (item.command) {
        item.command({
          originalEvent: event,
          item
        });
      }
      if (!this.multiple) {
        for (let modelItem of this.model) {
          if (item !== modelItem && modelItem.expanded) {
            modelItem.expanded = false;
          }
        }
      }
      item.expanded = !item.expanded;
      this.changeActiveItem(event, item, index);
      focus(event.currentTarget);
    }
    onHeaderKeyDown(event, item, index) {
      switch (event.code) {
        case 'ArrowDown':
          this.onHeaderArrowDownKey(event);
          break;
        case 'ArrowUp':
          this.onHeaderArrowUpKey(event);
          break;
        case 'Home':
          this.onHeaderHomeKey(event);
          break;
        case 'End':
          this.onHeaderEndKey(event);
          break;
        case 'Enter':
        case 'Space':
          this.onHeaderEnterKey(event, item, index);
          break;
        default:
          break;
      }
    }
    onHeaderArrowDownKey(event) {
      const rootList = getAttribute(event.currentTarget, 'data-p-highlight') === true ? findSingle(event.currentTarget.nextElementSibling, '[data-pc-section="rootlist"]') : null;
      rootList ? focus(rootList) : this.updateFocusedHeader({
        originalEvent: event,
        focusOnNext: true
      });
      event.preventDefault();
    }
    onHeaderArrowUpKey(event) {
      const prevHeader = this.findPrevHeader(event.currentTarget.parentElement) || this.findLastHeader();
      const rootList = getAttribute(prevHeader, 'data-p-highlight') === true ? findSingle(prevHeader.nextElementSibling, '[data-pc-section="rootlist"]') : null;
      rootList ? focus(rootList) : this.updateFocusedHeader({
        originalEvent: event,
        focusOnNext: false
      });
      event.preventDefault();
    }
    onHeaderHomeKey(event) {
      this.changeFocusedHeader(event, this.findFirstHeader());
      event.preventDefault();
    }
    onHeaderEndKey(event) {
      this.changeFocusedHeader(event, this.findLastHeader());
      event.preventDefault();
    }
    onHeaderEnterKey(event, item, index) {
      const headerAction = findSingle(event.currentTarget, '[data-pc-section="headerlink"]');
      headerAction ? headerAction.click() : this.onHeaderClick(event, item, index);
      event.preventDefault();
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵPanelMenu_BaseFactory;
      return function PanelMenu_Factory(__ngFactoryType__) {
        return (ɵPanelMenu_BaseFactory || (ɵPanelMenu_BaseFactory = i0.ɵɵgetInheritedFactory(PanelMenu)))(__ngFactoryType__ || PanelMenu);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: PanelMenu,
      selectors: [["p-panelMenu"], ["p-panelmenu"], ["p-panel-menu"]],
      contentQueries: function PanelMenu_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, _c6, 4)(dirIndex, _c7, 4)(dirIndex, _c8, 4)(dirIndex, PrimeTemplate, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.submenuIconTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerIconTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.itemTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templates = _t);
        }
      },
      viewQuery: function PanelMenu_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c9, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.containerViewChild = _t.first);
        }
      },
      hostVars: 2,
      hostBindings: function PanelMenu_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.cn(ctx.cx("root"), ctx.styleClass));
        }
      },
      inputs: {
        model: "model",
        styleClass: "styleClass",
        multiple: [2, "multiple", "multiple", booleanAttribute],
        transitionOptions: "transitionOptions",
        motionOptions: [1, "motionOptions"],
        id: "id",
        tabindex: [2, "tabindex", "tabindex", numberAttribute]
      },
      features: [i0.ɵɵProvidersFeature([PanelMenuStyle, {
        provide: PANELMENU_INSTANCE,
        useExisting: PanelMenu
      }, {
        provide: PARENT_INSTANCE,
        useExisting: PanelMenu
      }]), i0.ɵɵHostDirectivesFeature([i1.Bind]), i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [["htmlLabel", ""], ["htmlRouteLabel", ""], [4, "ngFor", "ngForOf"], [3, "class", "ngStyle", "pBind", 4, "ngIf"], [3, "ngStyle", "pBind"], ["role", "button", 3, "click", "keydown", "ngStyle", "pTooltip", "pTooltipUnstyled", "tabindex", "tooltipOptions", "pBind"], [3, "pBind"], [4, "ngIf"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "routerLink", "queryParams", "routerLinkActive", "routerLinkActiveOptions", "target", "class", "ngStyle", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "pBind", 4, "ngIf"], ["role", "region", "pMotionName", "p-collapsible", 3, "pBind", "pMotion", "pMotionOptions"], ["pPanelMenuList", "", 3, "headerFocus", "panelId", "items", "itemTemplate", "transitionOptions", "root", "activeItem", "tabindex", "parentExpanded", "pt", "unstyled", "motionOptions"], [3, "target", "class", "ngStyle", "pBind", 4, "ngIf"], [3, "target", "ngStyle", "pBind"], [3, "class", "ngStyle", "pBind", 4, "ngIf", "ngIfElse"], [3, "class", 4, "ngIf"], [4, "ngTemplateOutlet"], ["data-p-icon", "chevron-down", 3, "class", "pBind", 4, "ngIf"], ["data-p-icon", "chevron-right", 3, "class", "pBind", 4, "ngIf"], ["data-p-icon", "chevron-down", 3, "pBind"], ["data-p-icon", "chevron-right", 3, "pBind"], [3, "ngStyle", "innerHTML", "pBind"], [3, "routerLink", "queryParams", "routerLinkActive", "routerLinkActiveOptions", "target", "ngStyle", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "pBind"]],
      template: function PanelMenu_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, PanelMenu_ng_container_0_Template, 2, 1, "ng-container", 2);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngForOf", ctx.model);
        }
      },
      dependencies: [CommonModule, i2.NgForOf, i2.NgIf, i2.NgTemplateOutlet, i2.NgStyle, PanelMenuList, RouterModule, i3.RouterLink, i3.RouterLinkActive, TooltipModule, i4.Tooltip, i1.Bind, ChevronDownIcon, ChevronRightIcon, SharedModule, BindModule, MotionModule, i5.MotionDirective],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return PanelMenu;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PanelMenuModule = /*#__PURE__*/(() => {
  class PanelMenuModule {
    static ɵfac = function PanelMenuModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PanelMenuModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: PanelMenuModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [PanelMenu, SharedModule, SharedModule]
    });
  }
  return PanelMenuModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { PanelMenu, PanelMenuClasses, PanelMenuList, PanelMenuModule, PanelMenuStyle, PanelMenuSub };
